export default __webpack_public_path__ + "static/media/quora.a2eac18b.svg";